import { useQuery } from 'react-query'
import { useEffect, useState } from 'react'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { UserWithAppleId } from 'interfaces/user-with-apple-id'

type Data = {
  data: {
    users: UserWithAppleId[]
  }
}

const fetchOrganizationUsersWithAppleIds = async (organizationId: string) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${organizationId}/organization_users`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json: Data = await response.json()
  return json
}

export const useGetOrganizationUsersWithAppleIds = (
  organizationId: string,
  orgDataLoaded: boolean = false
) => {
  return useQuery(
    ['organization-users-with-apple-ids', organizationId],
    () => fetchOrganizationUsersWithAppleIds(organizationId),
    {
      enabled: !!organizationId && orgDataLoaded,
    }
  )
}
